
import logo from './../img/logo.svg'
import img_1f600 from './../img/1f600.svg'
import img_1f601 from './../img/1f601.svg'
import img_1f602 from './../img/1f602.svg'
import img_1f923 from './../img/1f923.svg'
import img_1f603 from './../img/1f603.svg'
import img_1f604 from './../img/1f604.svg'
import img_1f605 from './../img/1f605.svg'
import img_1f606 from './../img/1f606.svg'
import img_1f60a from './../img/1f60a.svg'
import img_1f60b from './../img/1f60b.svg'
import img_1f60e from './../img/1f60e.svg'
import img_1f60d from './../img/1f60d.svg'
import img_1f618 from './../img/1f618.svg'
import img_1f617 from './../img/1f617.svg'
import img_1f619 from './../img/1f619.svg'
import img_1f61a from './../img/1f61a.svg'
import img_263a from './../img/263a.svg'
import img_1f642 from './../img/1f642.svg'
import img_1f917 from './../img/1f917.svg'
import img_1f914 from './../img/1f914.svg'
import img_1f610 from './../img/1f610.svg'
import img_1f611 from './../img/1f611.svg'
import img_1f636 from './../img/1f636.svg'
import img_1f644 from './../img/1f644.svg'
import img_1f625 from './../img/1f625.svg'
import img_1f62e from './../img/1f62e.svg'
import clock from './../img/clock.svg'
import settings from './../img/settings.svg'
import sendGold from './../img/send-gold.svg'
import { useState, useRef, useEffect } from 'react';
import Config from '../Config';
import { Messages } from './Messages';


 
export function ClientChat(props)
{      
    const last = useRef(null);
    const chatRef = useRef(null);
    //const [last, setLast] = useState(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [enter_send, setEnterSend] = useState(true);
    const [auto_rewind, setAutoRewind] = useState(true);
    const [message, setMessage] = useState('');
    const [data, setData] = useState(props.userData);
    const [chatMessage, setChatMessage] = useState([]);
    const [chatData, setChatData] = useState({
        stan:"",
        pozostalo:"",
        ostatnia_aktywnosc:null,
        czas_trwania:null,
        koszt_rozmowy:null,
    });
    const [dataStart, setDataStart] = useState(null);
    const [dataStop, setDataStop] = useState(null);
    const [status, setStatus] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const [handle,setHandle] = useState(null);
     
   
    
    const getMessegas = () => {
        
        
        fetch(Config.url+'/rest,refresh_chat',{
            method:'POST',
            body: JSON.stringify(data), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.userData.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
           
            setChatMessage(res.chat_rows);
            setChatData(res.chat_data);
            setStatus(res.status);

            if(auto_rewind===true && chatData.stan!='ZAMKNIETY')
            {
                //console.log('getMessages',auto_rewind);
                //last.current?.scrollIntoView({ behavior: 'smooth', block: 'center'  });
            }
        })
        .catch(err => {
            console.log("Err " + err);
        });
    }

    const goBottom = (inx) => {
        
        //const element = dialogChatWindow[inx].current;
        //element.scrollTop = element.scrollHeight;
    }

    if(chatMessage.length==0 || chatMessage==undefined )
    {
        getMessegas();
    }

    const handleScroll = () => {

        
        setScrollTop(last.current.scrollTop);
      };

    useEffect(() => {

        

        const intervalId = setInterval(() => {
            
            if(chatData.stan!='ZAMKNIETY')
                getMessegas();
            
        }, 5000); // Pobieraj dane co 5 sekund


        const intervalRewind = setInterval(() => {
          
            if(auto_rewind===true && chatData.stan!='ZAMKNIETY')
            {       
                const chatContainer = chatRef.current;
                chatContainer.scrollTop = chatContainer.scrollHeight;

                //console.log(chatContainer);
                //last.current.scrollTop = last.current.scrollHeight;

                //last.current?.scrollIntoView({ behavior: 'smooth',  block: 'center'  });
            }     

        }, 1000); // Pobieraj dane co 5 sekund
    
        return () => {
            clearInterval(intervalId);
            clearInterval(intervalRewind);
        }
        
    }, [auto_rewind,chatData.stan,chatRef.current]);

    const sendMessage = () => {
        
        if(message.length==0) return;
        
        let send_data = (
            {
                crypt:props.userData.crypt,
                content_chat_text:message,
            }
        );

        fetch(Config.url+'/rest,add_message',{
            method:'POST',
            body: JSON.stringify(send_data), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.userData.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
           if(res.status=='OK')
           {
                getMessegas(); 
                setMessage('');
                
                if(auto_rewind===true)
                {
                    //last.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                
           }
           else
           {
             alert('wiadomość nie została wysłana spróbuj ponownie za chwilę');
           }
        })
        .catch(err => {
            console.log("Err " + err);
        });
    }

    const endChat = () => {
        
        let send_data = (
            {
                crypt:props.userData.crypt,
            }
        );

        fetch(Config.url+'/rest,end_chat',{
            method:'POST',
            body: JSON.stringify(send_data), 
            mode:'cors',
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.userData.apiKey
            }
        })
        .then(res => res.json() )
        .then(res => {
           
        })
        .catch(err => {
            console.log("Err " + err);
        });
    }
    
    const enterSend = (event) => {
        setEnterSend(!enter_send);
    }

    const autoRewind = (event) => {
        setAutoRewind(!auto_rewind);
    }
    
    const changeValue = (event) =>{
        
        var name = event.target.getAttribute('name'); 
        var value = event.target.value; 

        setMessage(value);
    }
    
    const onKeyDown = (event) =>{
        
        var name = event.target.getAttribute('name'); 
        var value = event.target.value; 

        setMessage(value);

        
        if(enter_send==1 && event.key=='Enter')
        {
            sendMessage();
        }
        
    }
    
    const addToChatText = (event) =>{
        
        var value = event.target.attributes.value.value; 
        
        setMessage(message+value);

    }

    const messageForm = () => {
        
        return (
            <div>
                <form action="#" class="mw-chat__form">
                                    <fieldset>
                                        <div class="mw-chat__textarea">
                                            <textarea id="content_chat_text" name='wiadomosc' value={message} onKeyDown={onKeyDown} onChange={changeValue} cols="30" rows="10"></textarea>
                                        </div>
                                        <div class="mw-chat__select-emoji">
                                            <button type="button" aria-label="Wstaw emotikonę" />
                                            
                                        </div>
                                        <div class="mw-chat__submit" onClick={sendMessage}  >
                                            <a href='#' class="mw-button" >
                                                <span>Wyślij</span> 
                                                <img src={sendGold}  alt="Wyślij" aria-hidden="true" />
                                            </a>
                                        </div>
                                    </fieldset>
        
                                    <div class="mw-chat__emoji">
                                        <a><img src={img_1f600}  onClick={addToChatText} value="😀" /></a>
                                        <a><img onClick={addToChatText} value="😁" src={img_1f601} /></a>
                                        <a><img onClick={addToChatText} value="😂" src={img_1f602} /></a>
                                        <a><img onClick={addToChatText} value="🤣" src={img_1f923} /></a>
                                        <a><img onClick={addToChatText} value="😃" src={img_1f603} /></a>
                                        <a><img onClick={addToChatText} value="😄" src={img_1f604} /></a>
                                        <a><img onClick={addToChatText} value="😅" src={img_1f605} /></a>
                                        <a><img onClick={addToChatText} value="😆" src={img_1f606} /></a>
                                        <a><img onClick={addToChatText} value="😊" src={img_1f60a} /></a>
                                        <a><img onClick={addToChatText} value="😋" src={img_1f60b} /></a>
                                        <a><img onClick={addToChatText} value="😎" src={img_1f60e} /></a>
                                        <a><img onClick={addToChatText} value="😍" src={img_1f60d} /></a>
                                        <a><img onClick={addToChatText} value="😘" src={img_1f618} /></a>
                                        <a><img onClick={addToChatText} value="😗" src={img_1f617} /></a>
                                        <a><img onClick={addToChatText} value="😙" src={img_1f619} /></a>
                                        <a><img onClick={addToChatText} value="😚" src={img_1f61a} /></a>
                                        <a><img onClick={addToChatText} value="🙂" src={img_1f642} /></a>
                                        <a><img onClick={addToChatText} value="🤗" src={img_1f917} /></a>
                                        <a><img onClick={addToChatText} value="🤔" src={img_1f914} /></a>
                                        <a><img onClick={addToChatText} value="😐" src={img_1f610} /></a>
                                        <a><img onClick={addToChatText} value="😑" src={img_1f611} /></a>
                                        <a><img onClick={addToChatText} value="😶" src={img_1f636} /></a>
                                        <a><img onClick={addToChatText} value="🙄" src={img_1f644} /></a>
                                        <a><img onClick={addToChatText} value="😥" src={img_1f625} /></a>
                                        <a><img onClick={addToChatText} value="😮" src={img_1f62e} /></a>
                                    </div>
                                     
                                    <div class="mw-chat__settings">
                                        <div class="mw-switches">
                                            <label >
                                                <input  id="enter_send"  checked={enter_send} type="checkbox" onChange={enterSend} />
                                                <span class="mw-switches__content">
                                                    <span class="mw-switches__name">
                                                        Enter wysyła
                                                    </span>
                                                    <span class="mw-switches__switch">
                                                        <span class="mw-switches__track"><span class="mw-switches__ball"></span></span>
                                                    </span>
                                                </span>
                                            </label>
                                            <label>
                                                <input type="checkbox" id="auto_scrool" checked={auto_rewind} onChange={autoRewind} />
                                                <span class="mw-switches__content">
                                                    <span class="mw-switches__name">
                                                        Automatyczne przewijanie
                                                    </span>
                                                    <span class="mw-switches__switch">
                                                        <span class="mw-switches__track"><span class="mw-switches__ball"></span></span>
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </form>
            </div>                    
        )

    }

    function summaryChat() {
        
        return (
            <div className="mw-chat__form"> 
                <div className="mw-chat__settings">
                    <label className='chat_summery'>
                        <span >Czat został zakończony - trwał {chatData.czas_trwania} minut i kosztował {chatData.koszt_rozmowy} zł  </span>
                        <br></br>
                        
                    </label>
                </div>
            </div>                    
        )

    }

    if(chatData.stan=='ZAMKNIETY')
        var showSummery=true;
    else
        var showSummery=false;

    
    return (
        <div>
            
            

            <input id='crypt' type='hidden' value={data.crypt} />
            <input id='last_index' autocomplete='off'  type='hidden' value='0' />
            <input type="hidden" autocomplete='off' id="ajax_timer" value='0' />
            <input type="hidden" autocomplete='off' id="ajax_action" value='0' />
            <input type="hidden" id="klient_nick" value='' />
            <input type="hidden" id="doradca_nick" value='' />
            <input type="hidden" autocomplete='off' id="ostani_czas_pisania" value='0' />
            <input type="hidden" autocomplete='off' id="end" value='0' />
        
        <div class="">
            <header class="mw-chat-header">
                <div class="mw-container">
                    <div class="mw-chat-header__container">
                        <div class="mw-chat-header__logo">
                        
                        </div>

                        <div class="mw-chat-header__actions">
                            <div class="mw-chat-header__time">
                                <div><img src={clock} alt="-" /></div>
                                <div>
                                    <em>Pozostało:</em>
                                    <strong id="chat_czas">{chatData.pozostalo} minut</strong>
                                </div>
                            </div>

                            <div class="mw-chat-header__settings">
                                <button type="button">
                                    <img src={settings} alt="Ustawienia" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <main class="mw-main">
                <section class="mw-chat">
                    <div class="mw-container">
                        <div class="mw-chat__container">
                            <div class="mw-chat__frame" /*style='position:relative'*/>
                                
                            <div class="mw-chat__conversation"  ref={chatRef}>
                                <ol id='chat__messages'  >
                                    {
                                        chatMessage.map( (row, ix ) => {
                                            if(row.typ=='D')
                                                {
                                                    return (
                                                        <li id={'id_ex_'+row.id} class="mw-chat__message">                    
                                                            <div class="mw-chat__avatar">                        
                                                                <img src={row.awatar} alt="Awatar Super ekspert" />
                                                            </div>                    
                                                            <div class="mw-chat__content">                        
                                                                <div class="mw-chat__meta">                            
                                                                    <div class="mw-chat__author">                                
                                                                        <a href="#">{row.id_nadawcy}</a>                            
                                                                    </div>                            
                                                                    <time class="mw-chat__time">
                                                                        {row.wpis}
                                                                    </time>                        
                                                                </div>                        
                                                                <div class="mw-chat__text">{row.tresc}</div>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                else
                                                {
                                                    return (
                                                        <li id="id_ex_4138385" class="mw-chat__message mw-chat__message--me">    
                                                            <div class="mw-chat__content">        
                                                                <div class="mw-chat__meta">            
                                                                    <div class="mw-chat__author">                
                                                                        <a href="#">{row.id_nadawcy}</a>            
                                                                    </div>            
                                                                    <time class="mw-chat__time">{row.wpis}</time>
                                                                </div>        
                                                                <div class="mw-chat__text">{row.tresc}</div>    
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                        })
                                    }
                                    
                                </ol>
                                
                            </div>

                            {showSummery ? summaryChat() : messageForm()}

                            
                                
                                
                            </div>

                            <div class="mw-chat__footer">
                                <div class="mw-chat__close">

                                {showSummery ? <a href='https://www.magicznewrota.pl' className="mw-button mw-button--ghost">Wróć</a> : <input type="button" value="Zakończ czat" className="mw-button mw-button--ghost" onClick={endChat} />}

                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
       
        </div>
    )
   
}
